<template>
  <fin-data-loader :resolver="loadData"
                   class="home"
                   fullpage>
    <template #content>
      <div>
        <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                     v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                     class="finAgb"
                     fluid>
          <v-row>
            <v-col cols="12">
              <h1 :style="`text-align: ${isDialog ? 'left': 'center'} !important;`">Allgemeine Geschäftsbedingungen</h1>
            </v-col>

            <v-col cols="11" md="6" class="justify-center align-center mx-auto mt-12">
              <fin-regulation-document-downloads :documents="[gtb]"/>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </template>
  </fin-data-loader>
</template>

<script>
import {finUserAPI} from '@/js/finAPI'
import FinDataLoader from "@/components/common/DataLoader"
import FinRegulationDocumentDownloads from "@/components/common/DocumentDownloads/RegulationDocumentDownloads"

export default {
  components: {FinRegulationDocumentDownloads, FinDataLoader},
  props: {
    isDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      gtb: undefined
    }
  },
  methods: {
    async loadData() {
      this.gtb = await finUserAPI.getLatestGeneralTerms()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables";
@import "../../styles/home";

.home {
  font-size: 16px;

  .finAgb {
    min-height: 80vh !important;
  }

  a {
    color: $fin-color-primary-dark !important;
    text-decoration: none;
  }

  h1 {
    color: $fin-color-primary-dark !important;
  }

  h2 {
    color: $fin-color-primary-dark !important;
    margin: 60px 0 6px 0;
    font-size: 32px;
  }

  p {
    color: $fin-color-primary-dark !important;
    margin: 12px 0 6px 0;
  }

  .container {
    padding: 32px 45px 32px 32px;
  }

  .col {
    padding-top: 0;
  }

  /* Definition for mobile (375px) - vuetify breakpoint for xs */

  @media only screen and (max-width: 600px) {

    h1 {
      font-size: 28px;
    }

    h2 {
      font-size: 22px;
    }

    h3 {
      font-size: 18px;
    }

    p {
      font-size: 16px;
    }

  }
}

</style>
